export enum ChildPersonaType {
  GRADE,
  MATH_ABILITY,
  ENGLISH_ABILITY,
  CHINESE_ABILITY,
  CONSTELLATION,
  ARITHMETIC_ABILITY,
}

export class ChildPersona {
  id: number;
  type: ChildPersonaType;
  value: number;
  child: Child;
  childId: number;
  customValue: string;
  createdAt: string;
}

export enum Gender {
  UNKNOWN,
  MALE,
  FEMALE,
}

export class Family {
  children: Child[];
  region: string;
  userId: number;
}

export class Child {
  birthday: string;
  family: Family;
  familyId: number;
  gender: Gender;
  name: string;
  personas: ChildPersona[];
  createdAt: string;
}



// WEBPACK FOOTER //
// ./src/types/family.ts